const FileUploadStatus = {
  STARTED: 'STARTED',
  DONE: 'DONE',
  ERROR: 'ERROR',
  CANCELED: 'CANCELED'
}

const initialState = {
  data: [],
};

export const reportCommentAttachment = () => (state = initialState, action) => {
  switch (action.type) {

    case `REPORT_COMMENT_ATTACHMENT_INITIAL`: {
      return {
        data: action.attachments.map(attachment =>
        ({
          name: attachment.name,
          lastModified: attachment.lastModified,
          size: attachment.size,
          type: attachment.type
        })
        )
      };
    }
    case `REPORT_COMMENT_ATTACHMENT_UPLOAD_STARTED`: {
      const fileStarted = {
        ...state.data[action.index],
        status: FileUploadStatus.STARTED,
        progress: 0
      };

      const updatedItems = state.data.map((item, index) => {
        if (index === action.index) {
          return fileStarted
        }

        return item;
      });

      return { data: updatedItems }
    }
    case `REPORT_COMMENT_ATTACHMENT_UPLOAD_SUCCESS`: {
      const fileSuccess = {
        ...state.data[action.index],
        status: FileUploadStatus.DONE,
        progress: 100
      };

      const updatedItems = state.data.map((item, index) => {
        if (index === action.index) {
          return fileSuccess
        }

        return item;
      });

      return { data: updatedItems }

    }
    case `REPORT_COMMENT_ATTACHMENT_UPLOAD_CANCELED`: {
      const fileCanceled = {
        ...state.data[action.index],
        status: FileUploadStatus.CANCELED
      };

      const updatedItems = state.data.map((item, index) => {
        if (index === action.index) {
          return fileCanceled
        }

        return item;
      });

      return { data: updatedItems }

    }
    case `REPORT_COMMENT_ATTACHMENT_UPLOAD_FAILURE`: {
      const fileFailure = {
        ...state.data[action.index],
        status: FileUploadStatus.ERROR,
      };

      const updatedItems = state.data.map((item, index) => {
        if (index === action.index) {
          return fileFailure
        }

        return item;
      });

      return { data: updatedItems }
    }
    case `REPORT_COMMENT_ATTACHMENT_PROGRESS_CHANGED`: {
      const fileProgress = {
        ...state.data[action.index],
        progress: action.progress
      };

      const updatedItems = state.data.map((item, index) => {
        if (index === action.index) {
          return fileProgress
        }

        return item;
      });

      return { data: updatedItems }
    }
    case `REPORT_COMMENT_ATTACHMENT_RESET`: {
      return initialState;
    }
    default:
      return state;
  }
};
